import { isProd, isDev, isLocal } from './env';

const localVersion = '/v1.1';
const devVersion = '/v1.1';
const stageVersion = '/v1.1';
const prodVersion = '';

const getApiUrl = () => {
  if (isLocal()) {
    return `https://api-stage.wingalpha.com${localVersion}/api/`;
  } if (isDev()) {
    return `https://api-dev.wingalpha.com${devVersion}/api/`;
  } else if (isProd()) {
    return `https://api.wingalpha.com${prodVersion}/api/`;
  } else {
    return `https://api-stage.wingalpha.com${stageVersion}/api/`
  }
}

export const API_URL = getApiUrl();

export const DUE_DATE_FORMAT = 'MMMM Do';
export const LONG_DATE_FORMAT = 'MMMM D, YYYY';
export const SHORT_DATE_FORMAT = 'D MMM YY';

export const TMOBILE_DATA_ONLY_SIM_ID = 928;
export const ATT_SIM_ID = 925;
export const TMOBILE_SIM_ID = 926;
export const VERIZON_SIM_ID = 927;
